import { render, staticRenderFns } from "./UpdateModel.vue?vue&type=template&id=245b2caf&"
import script from "./UpdateModel.vue?vue&type=script&lang=js&"
export * from "./UpdateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports